/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hof_Timeline_EmptyInputs */

const en_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moments from Mark's Hall of Fame will appear here soon.`)
};

const es_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto aparecerán aquí momentos del Salón de la Fama de Mark.`)
};

const de_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momente aus Marks Ruhmeshalle erscheinen hier bald.`)
};

const zh_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark名人堂的精彩瞬间即将在此呈现。`)
};

const ar_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ستظهر قريبًا هنا لحظات من قاعة المشاهير الخاصة بـ Mark.`)
};

const fr_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les moments du Temple de la renommée de Mark apparaîtront bientôt ici.`)
};

const vi_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Những khoảnh khắc từ Đại sảnh Danh vọng của Mark sẽ sớm xuất hiện tại đây.`)
};

const sw_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matukio kutoka Ukumbi wa Umaarufu wa Mark yataonekana hapa hivi karibuni.`)
};

const th_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ช่วงเวลาจากหอเกียรติยศของ Mark จะปรากฏที่นี่เร็ว ๆ นี้`)
};

const bs_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenuci iz Markove Kuće slavnih uskoro će se pojaviti ovdje.`)
};

const ja_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markのホール・オブ・フェイムの思い出が、まもなくここに表示されます。`)
};

const ko_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark의 명예의 전당 순간이 곧 여기에 표시됩니다.`)
};

const pt_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momentos do Hall da Fama de Mark aparecerão aqui em breve.`)
};

const it_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I momenti della Hall of Fame di Mark appariranno qui a breve.`)
};

const sv_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ögonblick från Marks Hall of Fame visas här snart.`)
};

const nl_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momenten uit Marks Hall of Fame verschijnen hier binnenkort.`)
};

const da_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Øjeblikke fra Marks Hall of Fame vises her snart.`)
};

const nb_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Øyeblikk fra Marks Hall of Fame dukker snart opp her.`)
};

const fi_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hetket Markin Hall of Famesta ilmestyvät tänne pian.`)
};

const pl_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chwile z Galerii Sław Marka pojawią się tu wkrótce.`)
};

const ru_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Моменты из Зала славы Mark скоро появятся здесь.`)
};

const tr_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark'ın Hall of Fame anları yakında burada görünecek.`)
};

const hi_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark के हॉल ऑफ फेम के क्षण जल्द यहाँ दिखेंगे।`)
};

const id_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momen dari Hall of Fame Mark akan segera muncul di sini.`)
};

const ms_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momen dari Dewan Kemasyhuran Mark akan dipaparkan di sini tidak lama lagi.`)
};

const cs_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momenty z Markovy Síně slávy se zde brzy objeví.`)
};

const el_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Στιγμές από το Hall of Fame του Mark θα εμφανιστούν σύντομα εδώ.`)
};

const he_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`רגעים מהיכל התהילה של Mark יופיעו כאן בקרוב.`)
};

const af_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momente uit Mark se Hall of Fame verskyn binnekort hier.`)
};

const hu_hof_timeline_empty = /** @type {(inputs: Hof_Timeline_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Hírességek Csarnokának pillanatai hamarosan itt jelennek meg.`)
};

/**
* | output |
* | --- |
* | "Moments from Mark's Hall of Fame will appear here soon." |
*
* @param {Hof_Timeline_EmptyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const hof_timeline_empty = /** @type {((inputs?: Hof_Timeline_EmptyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hof_Timeline_EmptyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_hof_timeline_empty(inputs)
	if (locale === "de") return de_hof_timeline_empty(inputs)
	if (locale === "zh") return zh_hof_timeline_empty(inputs)
	if (locale === "ar") return ar_hof_timeline_empty(inputs)
	if (locale === "fr") return fr_hof_timeline_empty(inputs)
	if (locale === "vi") return vi_hof_timeline_empty(inputs)
	if (locale === "sw") return sw_hof_timeline_empty(inputs)
	if (locale === "th") return th_hof_timeline_empty(inputs)
	if (locale === "bs") return bs_hof_timeline_empty(inputs)
	if (locale === "ja") return ja_hof_timeline_empty(inputs)
	if (locale === "ko") return ko_hof_timeline_empty(inputs)
	if (locale === "pt") return pt_hof_timeline_empty(inputs)
	if (locale === "it") return it_hof_timeline_empty(inputs)
	if (locale === "sv") return sv_hof_timeline_empty(inputs)
	if (locale === "nl") return nl_hof_timeline_empty(inputs)
	if (locale === "da") return da_hof_timeline_empty(inputs)
	if (locale === "nb") return nb_hof_timeline_empty(inputs)
	if (locale === "fi") return fi_hof_timeline_empty(inputs)
	if (locale === "pl") return pl_hof_timeline_empty(inputs)
	if (locale === "ru") return ru_hof_timeline_empty(inputs)
	if (locale === "tr") return tr_hof_timeline_empty(inputs)
	if (locale === "hi") return hi_hof_timeline_empty(inputs)
	if (locale === "id") return id_hof_timeline_empty(inputs)
	if (locale === "ms") return ms_hof_timeline_empty(inputs)
	if (locale === "cs") return cs_hof_timeline_empty(inputs)
	if (locale === "el") return el_hof_timeline_empty(inputs)
	if (locale === "he") return he_hof_timeline_empty(inputs)
	if (locale === "af") return af_hof_timeline_empty(inputs)
	if (locale === "hu") return hu_hof_timeline_empty(inputs)
	return en_hof_timeline_empty(inputs)
});